import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import config from '../../config.js';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import moment from 'moment';
import 'moment/locale/pt-br';
import 'moment/locale/es';

import { appDone,
         appWait,
         appSetConfig,
         appSetRouteDone} from '../../store/actions/app.js';

import { dialogOpen, 
         dialogClose,
         dialogWait } from '../../store/actions/msgDialog.js';

import ServDeliv from './ServDeliv.js';
import ServLogin from './ServLogin.js';
import ServSensors from './ServSensors.js';

class Cservices extends Component{
    constructor(props){
        super(props);

//*** Instance Variables
        this.delivDisconect = null;
        this.sensorsDisconect = null;
        
        this._dialogBtn1 = ()=>{};
        this._dialogBtn2 = ()=>{};

//*** State
        this.state={};

//*** Methods
        this._handleDialog = this._handleDialog.bind(this);
    }
    
    componentDidMount(){
        let remote_version = 
            parseInt(config.version.match(/\d+/g)[0] * 10000,10) +
            parseInt(config.version.match(/\d+/g)[1] * 1000,10) +
            parseInt(config.version.match(/\d+/g)[2],10);

        let local_version = 
            parseInt(this.props.version.match(/\d+/g)[0] * 10000,10) +
            parseInt(this.props.version.match(/\d+/g)[1] * 1000,10) +
            parseInt(this.props.version.match(/\d+/g)[2],10);

        //*** Refresh on new version        
        if (remote_version > local_version){
            // window.persistor.flush();
            // window.persistor.purge();
            window.location.replace("/");
            window.location.reload(true);
            return;
        }

        //*** moment.js
        moment.locale('en');

        //Disable Back button
        window.onpopstate = function (e) {
            window.history.forward();
        };

        //*** Firebase
        firebase.initializeApp(config.firebase);

        firebase.firestore()
        .enablePersistence({experimentalTabSynchronization:true})
        .then(()=>{
            this.props.appSetConfig(config);            

            if (this.props.loginState!==0){
                this.props.history.replace(this.props.route);   
            } else {
                this.props.history.replace('/login');
            }

        }).catch((err)=>{
            if (err.code === 'failed-precondition') {
                alert('Error: Failed Db Initialization. Multiple Tabs.');
                console.error(err);
            } else if (err.code === 'unimplemented') {
                alert('Error: Failed Db Initialization. Unsupported browser.');
                console.error(err);
            }
        });
    }

    componentDidUpdate(){
        this._handleRequests();
        this._handleDialog();
    }
    
    render(){
      return (
        <div>
            <ServDeliv />
            <ServLogin />
            <ServSensors />
        </div>
      );
    }

    //********************************
    _handleRequests(){
        switch (this.props.appState) {
            case 3:
                this._setRoute();
                break;
        
            default:
                break;
        }
    }

    _dialogClose(){
        this.props.dialogClose();
    }

    _handleDialog(){
        if (this.props.dialogState !== 2){ return };
        
        this.props.dialogWait();

        if (this.props.dialogBtn === 1){ 
            this.props.dialogBtn1();
        };

        if (this.props.dialogBtn === 2){ 
            this.props.dialogBtn2(); 
        };
    }

    _setRoute(){
        appSetRouteDone();
        appDone();
        if (window.location.pathname.split('/')[1]!==this.props.route){
            this.props.history.push(this.props.route);
        }
    }
}

const mapStateToProps = state => {
    return {
        activeTab: state.app.activeTab, 
        appState: state.app.appState,
        loginState: state.login.loginState,

        dialogState: state.msgDialog.dialogState,
        dialogBtn: state.msgDialog.dialogBtn,
        dialogBtn1: state.msgDialog.dialogBtn1,
        dialogBtn2: state.msgDialog.dialogBtn2,

        route: state.app.route,
        
        version: state.app.version
    }
}

const mapDispatchToProps = dispatch => {
    return {
        appDone: () => dispatch(appDone()),
        appWait: () => dispatch(appWait()),
        appSetConfig: (config) => dispatch(appSetConfig(config)),
        appSetRouteDone: () => dispatch(appSetRouteDone()),

        dialogOpen: (data) => dispatch(dialogOpen(data)),
        dialogClose: () => dispatch(dialogClose()),
        dialogWait: () => dispatch(dialogWait())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Cservices));


// WEBPACK FOOTER //
// ./src/containers/Cservices/index.js